/**
 * @desc
 * - Each value is a string of classes that will be applied to various HTML elements
 * - The cs-icon-* classes is a convention that will allow customizing styles, even if the other classes change
 * - In other words, the cs-icon-* classes should be constant over time
 */
;(function () {
  angular.module('contrast.icons').factory('csIconConfig', [csIconConfig])

  function csIconConfig() {
    return require('./cs-icon.json')
  }
})()
